import FileSaver from 'file-saver';
import { changeDateFormate } from '../../../utils/dateFormat';

const formatShoutOutcolumns = (exportData: any) => {
    const expAge = [{}];
    for (let i = 0; i < exportData.length; i++) {
        expAge.push({
            'S.No': `${i + 1}`,
            'Coaching_ShoutOut_ID': `${exportData[i].coaching_shout_out_id}`,
            'ShoutOut_Title': `${exportData[i].shout_out_title}`,
            'ShoutOut_Description': `${exportData[i].shout_out_description}`,
            'Recipient': `${exportData[i].recipient}`,
            'Author': `${exportData[i].author}`,
            'Start_Date': `${changeDateFormate(exportData[i].start_date)}`,
            'End_Date': `${changeDateFormate(exportData[i].end_date)}`,
            'Coaching_Entity_Type': `${exportData[i].coaching_entity_type_name}`,
        });
    }
    return expAge;
};
export const exportExcel = (data: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(formatShoutOutcolumns(data));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'ShoutOutView');
    });
};
export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};

export const GetTeamOptions = () => {
    const teamOptions: any = [];
    teamOptions.push({ name: 'My Shout Outs', code: 'myActivity' });
    teamOptions.push({ name: 'Shout Outs Created by Me', code: 'mycreatedshoutouts' });
    teamOptions.push({ name: 'My Team Shout Outs', code: 'myTeamActivity' });
    teamOptions.push({ name: 'Search', code: 'search' });
    return teamOptions;
}

export const getRole = (role: string,isPseudoSupervisor:boolean) => {

    if (isPseudoSupervisor===true) return 'supervisor';

    if (role === 'Non-Manager') return 'associate';
    else if (role === 'Supervisor 1' || role === 'Supervisor 2') return 'supervisor';
    else if (role === 'Manager 1' || role === 'Manager 2') return 'manager';
    else if (role !== '' && role !== 'Non-Manager' && role !== 'Supervisor 1'&& role !== 'Supervisor 2'&& role !== 'Manager 1'&& role !== 'Manager 2') return 'director';
    else return '';
}